import { Typography } from "@mui/material";

export default function AccountBilled({ customer }: any) {
  return (
    <>
      <Typography fontSize={14} sx={{ textTransform: 'uppercase' }}>{customer?.customer_id} - {customer?.customer_name}</Typography>
      <Typography fontSize={14} sx={{ textTransform: 'uppercase' }}>{customer?.customer_email}</Typography>
      {customer?.customer_address && <Typography fontSize={14} sx={{ textTransform: 'uppercase' }}>{customer?.customer_address}</Typography>}
      {customer?.customer_district?.label && <Typography fontSize={14} sx={{ textTransform: 'uppercase' }}>{customer?.customer_district?.label}, {customer?.customer_province?.label}</Typography>}
      {customer?.customer_country?.label && <Typography fontSize={14} sx={{ textTransform: 'uppercase' }}>{customer?.customer_country?.label}</Typography>}
      {customer?.customer_zipcode && <Typography fontSize={14} sx={{ textTransform: 'uppercase' }}>{customer?.customer_zipcode}</Typography>}
    </>
  )
}